<div class="clinic-card d-flex flex-column flex-sm-row gap-3 p-sm-0 p-lg-3 mt-md-3 mt-0"
  [@cardAnimation]="animationState">

  <ng-container *ngIf="screenSize.isMobile; else desktopContent">
    <ng-template [ngTemplateOutlet]="mobileContent"></ng-template>
  </ng-container>

  <ng-template #desktopContent>
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </ng-template>

</div>

<ng-template #mobileContent>

  <div class="clinic-inner-content d-flex justify-content-between align-items-stretch w-100" style="height: 130px;">

    <div class="img-container flex-shrink-0">
      <app-shimmer-loader height="100%" width="100%"></app-shimmer-loader>
    </div>

    <div class="d-flex flex-column justify-content-between title-container flex-grow-1">

      <!-- TITOLO -->
      <div class="w-100 h-50">
        <h5 class="d-flex flex-row w-100 justify-content-between align-items-top mb-1">
          <div class="d-flex flex-column">
            <span class="text-break flex-grow-1 fw-semibold small">
              <app-shimmer-loader height="16px" width="120px"></app-shimmer-loader>
            </span>
            <div class="subtitle-container small text-muted d-flex flex-column align-items-start pb-1 text-break">
              <app-shimmer-loader height="12px" width="80px"></app-shimmer-loader>
            </div>
          </div>
          <div class="d-flex flex-column align-items-end justify-content-top gap-1" style="cursor: pointer;">
            <app-shimmer-loader height="24px" width="32px"></app-shimmer-loader>
            <app-shimmer-loader height="14px" width="66px"></app-shimmer-loader>
          </div>
        </h5>

        <ng-template [ngTemplateOutlet]="languages"></ng-template>

      </div>

      <!-- CONTENUTO -->
      <div class="d-flex flex-column justify-content-between w-100  h-50 mt-2">
        <!-- RECENSIONE -->
        <app-shimmer-loader height="16px" width="80%"></app-shimmer-loader>

        <!-- FOOTER -->

        <div class="d-flex justify-content-end align-items-center">
          <app-shimmer-loader height="24px" width="100px"></app-shimmer-loader>
        </div>


      </div>
    </div>


  </div>
</ng-template>

<ng-template #content>

  <!-- COVER IMAGE -->
  <div class="ratio ratio-1x1 w-100 w-sm-auto flex-shrink-0" style="max-width: 200px;">
    <app-shimmer-loader height="100%" width="100%"></app-shimmer-loader>
  </div>

  <!-- CONTENUTO -->
  <div class="d-flex flex-column justify-content-between w-100 gap-3">

    <!-- TITOLO -->
    <div>
      <h5 class="d-flex flex-row justify-content-between align-items-center gap-2 mb-1 w-100">
        <span class="text-break  flex-grow-1 partner-name fw-semibold">
          <app-shimmer-loader height="16px" width="120px"></app-shimmer-loader>
        </span>
        <div class="d-flex flex-row align-items-center gap-2" style="cursor: pointer;">
          <app-shimmer-loader height="14px" width="66px"></app-shimmer-loader>
          <app-shimmer-loader height="24px" width="32px"></app-shimmer-loader>
        </div>
      </h5>

      <div class="subtitle-container small text-muted d-flex flex-column align-items-start pb-1">
        <app-shimmer-loader height="12px" width="80px"></app-shimmer-loader>
      </div>

      <ng-template [ngTemplateOutlet]="languages"></ng-template>

    </div>

    <!-- RECENSIONE -->
    <app-shimmer-loader height="18px" width="80%"></app-shimmer-loader>

    <!-- FOOTER -->

    <div class="d-flex justify-content-end align-items-center">
      <app-shimmer-loader height="24px" width="100px"></app-shimmer-loader>
    </div>

  </div>

</ng-template>

<ng-template #languages>
  <div class="d-flex align-items-center gap-1 flex-wrap flags">
    <app-shimmer-loader height="12px" width="60px"></app-shimmer-loader>
  </div>
</ng-template>